import { Typography } from '@/ui';

import type { PulseReportAnswer } from '@/types';
import type { FC } from 'react';

interface AnswerFreeformProps {
  answer: Extract<PulseReportAnswer, { kind: 'freeform' }>;
}

const AnswerFreeform: FC<AnswerFreeformProps> = ({ answer }) => (
  <div className="flex flex-col gap-3">
    <Typography className="text-cement-600" variant="subtitle1">
      {answer.prompt}
    </Typography>
    <div
      className="rounded-xl border border-sage-200 bg-sage-100 px-4 py-3"
      data-testid="freeform-answer-response"
    >
      <Typography
        className="whitespace-pre-line"
        color="text.secondary"
        variant="h5"
      >
        {answer.text}
      </Typography>
    </div>
  </div>
);

export default AnswerFreeform;
